import { render } from "./emp_compliance_health.vue?vue&type=template&id=08d8e9ee&scoped=true"
import script from "./emp_compliance_health.vue?vue&type=script&lang=js"
export * from "./emp_compliance_health.vue?vue&type=script&lang=js"

import "./emp_compliance_health.vue?vue&type=style&index=0&id=08d8e9ee&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d8e9ee"]])

export default __exports__